<div class="notification-container" aria-live="polite">
  @for(notification of notifications$ | async; track notification.id) {
  <div [class]="'notification ' + notification.type" [@slideIn]
    [attr.role]="notification.type === 'error' || notification.type === 'warning' ? 'alert' : null"
    [attr.aria-live]="notification.type === 'error' || notification.type === 'warning' ? 'assertive' : null">
    <div class="notification-content">
      <div class="notification-body">
        @if(notification.title){
        <h4 class="notification-title">
          {{ notification.title  }}
        </h4>
        }
        <p class="notification-message">
          {{ notification.message  }}
        </p>
      </div>

      <button type="button" class="notification-close" (click)="dismiss(notification.id)" aria-label="Chiudi notifica">
        <i class="material-icons" aria-hidden="true">close</i>
      </button>
    </div>

    @if(notification.autoClose){
    <div class="notification-progress" [style.animation-duration.ms]="notification.duration">
    </div>
    }
  </div>
  }
</div>